import axios from "axios";

//state
export var ruleState = {
  rules: [],
  rule: {},
  status_rule: ""
};

//getters
export var ruleGetters = {
  //funciones para optener informacion del state
  getRules: state => state.rules
};

//actions
export var ruleActions = {
  async getRules({ commit }) {
    commit("rule_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        var rules = [
          {
            name: "rule facebook 1",
            id: "1",
            apply_rule_to: "Todas las campañas activas",
            account_id: "1",
            conditions: "condicion 1",
            start_hour: "18:00",
            email_notifications: true,
            subcriber_id: "3"
          },
          {
            name: "rule facebook 2",
            id: "4",
            apply_rule_to: "Todas las campañas pausadas",
            account_id: "2",
            conditions: "condicion 2",
            start_hour: "13:00",
            email_notifications: true,
            subcriber_id: "4"
          },
          {
            name: "rule facebook 3",
            id: "3",
            apply_rule_to: "Todas las campañas activas",
            account_id: "3",
            conditions: "condicion 3",
            start_hour: "11:00",
            email_notifications: true,
            subcriber_id: "1"
          }
        ];
        commit("rule_success", rules);
        return res;
      })
      .catch(err => {
        commit("rule_error");
        return err;
      });
  },
  async newRule({ commit, state }, rule) {
    commit("offert_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        var rules = state.rules;
        rules.push(rule);
        commit("rule_success", rules);
        return rules;
      })
      .catch(err => {
        commit("rule_error");
        return err;
      });
  },
  async editRule({ commit, state }, rule) {
    commit("rule_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        var rules = state.rules;
        var index = rules.findIndex(element => {
          return element.id == rule.id;
        });
        rules.splice(index, 1);
        rules.splice(index, 0, rule);
        commit("rule_success", rules);
        return rules;
      })
      .catch(err => {
        commit("rule_error");
        return err;
      });
  }
};

//mutations

export var ruleMutations = {
  rule_request(state) {
    state.status_rule = "loading";
  },
  rule_success(state, payload) {
    state.status_rule = "success";
    state.rules = payload;
  },
  rule_error(state) {
    state.status_rule = "error";
  }
};
